<template>
  <base-layout pageTitle="Startseite">
    <div class="content-wrapper">

      <ion-grid style="flex: 1;">
        <ion-row class="ion-justify-content-center ion-align-items-start" style="flex: 1;">
          <ion-col size="12" size-md="12" style="height: 100%;">

                <ChatHistory :chatHistory="chatHistory"/>
                <ChatInput
                    :userInput="userInput"
                    :loading="loading"
                    :sendMessage="sendMessage"
                    :onInputChange="onInputChange"
                    :resetChat="resetChat"
                />

                <PromptsSection :prompts="prompts" :usePrompt="usePrompt"/>

          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </base-layout>
</template>




<script>
import axios from 'axios';

// import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/css';
// import 'swiper/swiper-bundle.css';
// import '@ionic/vue/css/ionic-swiper.css';

// import AppHeader from '@/components/page/Header.vue';
// import AppFooter from '@/components/page/Footer.vue';
import ChatHistory from '@/components/chat/ChatHistory.vue';
import ChatInput from '@/components/chat/ChatInput.vue';
import PromptsSection from '@/components/chat/PromptsSection.vue';

import {
  // IonContent,
  // IonPage,
  // IonList,
  // IonItem,
  // IonLabel,
  IonCol,
  IonRow,
  IonGrid,
  // IonCard,
  // IonCardContent

} from '@ionic/vue';

export default {
  name: 'OpenAIChat',
  components: {
    // IonButton, IonButtons,
    // AppHeader,
    // AppFooter,
    ChatHistory,
    ChatInput,
    PromptsSection,
    // IonHeader,
    // IonMenu,
    // IonTitle,
    // IonToolbar,
    // IonContent,
    // IonPage,
    // Swiper, SwiperSlide,
    // IonList, IonItem, IonLabel,
    IonCol, IonRow, IonGrid,
    // IonCard, IonCardContent
  },
  data() {
    return {
      slideOpts: {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      images: [
        {
          src: require('@/assets/slider/image-01.jpg'),
          alt: 'Bildbeschreibung 1',
        },
        {
          src: require('@/assets/slider/image-02.jpg'),
          alt: 'Bildbeschreibung 2',
        },
        {
          src: require('@/assets/slider/image-03.jpg'),
          alt: 'Bildbeschreibung 3',
        },
      ],
      userInput: '',
      loading: false,
      chatHistory: [],
      prompts: [
        {
          category: 'Aktuelles',
          prompts: [
            {
              text: 'Was sind die neuesten Nachrichten aus Thüringen?',
              icon: 'newspaper-outline',
            },
            {
              text: 'Wo finde ich eine Übersicht aktueller Veranstaltungen?',
              icon: 'people-outline',
            },
            {
              text: 'Zeige mir die neusten dpa-Meldungen',
              icon: 'newspaper-outline',
            },
            {
              text: 'Was sind die neuesten Stationen der Sommertour?',
              icon: 'walk-outline',
            },
          ],
        },
        {
          category: 'Service',
          prompts: [
            {
              text: 'Wie wird das Wetter morgen in Erfurt?',
              icon: 'cloudy-outline',
            },
            {
              text: 'Wo kann ich mich in meinem neuen Wohnort ummelden?',
              icon: 'information-outline',
            },
            {
              text: 'Was läuft aktuell im Kino?',
              icon: 'film-outline',
            },
            {
              text: 'Wo finde ich Sportvereine in Thüringen?',
              icon: 'american-football-outline',
            },
          ],
        },
        {
          category: 'Wissen',
          prompts: [
            {
              text: 'Was ist ein Landtag?',
              icon: 'home-outline',
            },
            {
              text: 'Erklären Sie mir die Bedeutung der Thüringer Staatskanzlei.',
              icon: 'business-outline',
            },
            {
              text: 'Wo finde ich was in Thüringen',
              icon: 'help-outline',
            },
            {
              text: 'Wann wird wieder gewählt in Thüringen?',
              icon: 'analytics-outline',
            },
          ],
        },
        {
          category: 'Test',
          prompts: [
            {
              text: 'Wie gut ist die Kulturpolitik in Thüringen?',
              icon: 'help-outline',
            },
            {
              text: 'Wer ist Michael Jackson?',
              icon: 'musical-note-outline',
            },
          ],
        },
      ],
    };
  },
  methods: {
    async sendMessage() {
      if (this.loading || !this.userInput) return;

      this.loading = true;
      this.chatHistory.push({role: 'user', content: this.userInput});

      const MAX_MESSAGES = 10;
      if (this.chatHistory.length > MAX_MESSAGES) {
        this.chatHistory = this.chatHistory.slice(-MAX_MESSAGES);
      }

      const endpoint = process.env.VUE_APP_OPENAI_ENDPOINT;
      const apiKey = process.env.VUE_APP_OPENAI_API_KEY;
      const deploymentName = process.env.VUE_APP_OPENAI_DEPLOYMENT_NAME;
      const apiVersion = process.env.VUE_APP_OPENAI_API_VERSION;

      try {
        const result = await axios.post(
            `${endpoint}/openai/deployments/${deploymentName}/chat/completions?api-version=${apiVersion}`,
            {
              messages: this.chatHistory,
              max_tokens: 500,
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'api-key': apiKey,
              },
            }
        );

        const assistantMessage = result.data.choices[0].message;
        this.chatHistory.push(assistantMessage);
        this.userInput = '';
      } catch (error) {
        console.error('Fehler bei der Anfrage:', error);
        this.$emit('showError', 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
      } finally {
        this.loading = false;
      }
    },
    usePrompt(prompt) {
      this.userInput = prompt.text;
      this.sendMessage();
    },
    onInputChange(event) {
      this.userInput = event.detail.value;
    },
    resetChat() {
      console.log('Chat zurücksetzen');
      this.chatHistory = [];
      this.userInput = '';
    },
    navigateTo(page) {
      this.$router.push({name: page});
    },
  },
};
</script>

<style scoped>
ion-page {
  height: 100%;
}

ion-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}


.slider-container {
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
}
</style>